import config from '~/config';
import { screenshot } from '~/services/thumbnail';

// this function basically helps blur the poster image in video-js.
// using vanilla js for the most part to capture the video-js node
// to blur the image and add a div layer on top for button
export function blurMask(videoContainer, player) {
  const element = videoContainer.getElementsByClassName('vjs-poster')[0];
  // blur poster image
  element.className += ' blur';

  const videoElement = videoContainer.getElementsByClassName('video-js')[0];

  const streamMask = document.createElement('div');
  streamMask.className = 'stream-mask';

  const streamMaskContainer = document.createElement('container');
  streamMaskContainer.className = 'stream-mask-container';

  const streamMaskContainerTitle = document.createElement('h2');
  streamMaskContainerTitle.innerHTML = 'Adult Content';

  const streamMaskContainerAction = document.createElement('h3');
  streamMaskContainerAction.innerHTML = 'Click To Show';
  // streamMaskContainer.innerHTML = 'This stream may contain adult content - click to view'

  // bring forward masking element for player.
  videoElement.appendChild(streamMask);

  streamMask.appendChild(streamMaskContainer);

  // show warning text.
  streamMaskContainer.appendChild(streamMaskContainerTitle);
  streamMaskContainer.appendChild(streamMaskContainerAction);

  // unblur image. and bring back play button
  streamMask.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    element.className = 'vjs-poster';
    videoElement.removeChild(streamMask);
    player.addChild('BigPlayButton');
  });

  return streamMaskContainer;
}

export function addWarningButtons(
  streamMaskContainer,
  navigateToSettingsPage,
  updateFilterState
) {
  const contentSettings = document.createElement('Button');
  const warningReminder = document.createElement('Button');

  contentSettings.className = 'unblur-stream';
  contentSettings.innerHTML = 'Manage content settings';
  contentSettings.addEventListener('click', navigateToSettingsPage);

  warningReminder.className = 'warning-reminder';
  warningReminder.innerHTML = 'Always show adult content';
  warningReminder.addEventListener('click', updateFilterState);

  streamMaskContainer.appendChild(contentSettings);
  streamMaskContainer.appendChild(warningReminder);
}

export function streamScreenshotURL({ id }) {
  return screenshot(id);
}

/**
 * Map streams to their current screenshot object url
 */
const streamScreenshots = {};

/**
 * Loads a screenshot from the current stream and returns the generated URL for it
 *
 * @param {Number} streamId - the id of the stream
 * @param {Boolean} isBlacklisted - whether or not the stream is blacklisted by the user
 *
 * @return Promise<String> A promise that resolves to the  URL Of the object
 */
export async function loadStreamScreenshot(streamId, isBlacklisted = false) {
  try {
    if (isBlacklisted) {
      return `${config.static}/images/blacklisted_stream.png`;
      // } else if (streamAdult && userNSFW) {
      //   return Promise.resolve(`${config.static}/images/adult_stream_warning.png`);
    }

    const response = await fetch(`${streamScreenshotURL({ id: streamId })}`);

    const blob = await response.blob();

    const url = URL.createObjectURL(blob);

    if (streamScreenshots[streamId]) {
      URL.revokeObjectURL(streamScreenshots[streamId]);
    }

    streamScreenshots[streamId] = url;

    return url;
  } catch (error) {
    return `${config.static}/images/default_stream.png`;
  }
}

/**
 * Opens a new window with the stream only
 *
 * @param {Object} stream - The stream object
 */
export function popoutStream(stream) {
  window.open(
    `/watch/${stream.user.username}/popout_stream/${stream.id}`,
    '_blank',
    'height=600,width=800'
  );
}
